<template>
    <div>
        <slot :active="active" :toggle="toggle" :activate="onActivate"/>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Inject, Prop, Ref } from 'vue-property-decorator';

@Component
export default class SimpleTab extends Vue {
    @Inject({ default: () => null }) readonly register!: (tab: SimpleTab) => void;
    @Inject({ default: () => null }) readonly activate!: (tab: SimpleTab) => void;

    active = false;

    onActivate(): void {
        this.activate(this);
    }

    toggle(): void {
        if (this.active) {
            this.active = false;
        } else {
            this.onActivate();
        }
    }

    mounted(): void {
        this.register(this);
    }
}
</script>
